export default {"src":"/_next/static/media/block-fabric.740ce743.svg","height":80,"width":560};